import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { ISwitchButton } from './../../interfaces/components/switch-button';


@Component({
  selector: 'app-switch-button',
  templateUrl: './switch-button.component.html',
  styleUrls: ['./switch-button.component.scss']
})
export class SwitchButtonComponent implements OnInit, OnChanges {

  @Input() public config: ISwitchButton;
  @Input() public switchStatus: boolean;
  @Input() public disabledSwitch: boolean;
  @Input() public leftLabel: string;
  @Input() public rightLabel: string;
  @Input() public preventChange = false;


  @Output() public switchEvent = new EventEmitter<boolean>();

  public status: boolean;
  public switchColor: string;

  /**
   * On init component
   */
  public ngOnInit(): void {
    this.status = this.switchStatus;
    this.changeColor();
  }

  /**
   * On change component
   */
  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.switchStatus) {
      this.status = changes.switchStatus.currentValue;
      this.changeColor();
    }
  }

  /**
   * Change switch button color
   */
  private changeColor(): void {
    this.switchColor = this.status ? this.config.activeColor : this.config.inactiveColor;
  }

  /**
   * catch the switch event
   */
  public switch(e: any): void {
    if (this.preventChange) {
      e.preventDefault();
      return;
    }
    this.status = e.target.checked;
    this.changeColor();
    this.switchEvent.emit(e.target.checked);
  }
}
